module.exports = __webpack_public_path__ + "media/images/avatar-7c6211b975c839d5f05f79adf755bccd.png";